// extracted by mini-css-extract-plugin
export default {"inputBase":"inputBase-w7xfr0"};